module.exports = __webpack_public_path__ + "static/media/EmptyProjectsNew.56e73d41.png";